// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { ifProp } from 'styled-tools';
import { defaultTo, toString } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { DateUtils } from 'react-day-picker';
import { format } from 'date-fns';

import SubscriptionTooltip from '../ToolTip';

type Props = {
  name: string,
  selectedFrom: Date | null,
  selectedTo: Date | null,
  disabled?: boolean,
  options: Array<{
    label: string,
    fromDate: Date,
    toDate: Date,
    disabled?: boolean,
  }>,
  onChange: (fromDate: Date, toDate: Date) => any,
};

const Options = styled.ul`
  display: inline-flex;
  font-size: 0.9em;
  color: #3c4042;
  border-radius: 4px;
  user-select: none;
  white-space: nowrap;

  ${breakpoint('tablet')`
    display: inline-flex;
  `};

  ${ifProp(
    'disabled',
    css`
      cursor: not-allowed;
    `,
  )};

  > div {
    &:first-child {
      li {
        margin-left: 0;
      }
    }

    &:first-child,
    &:last-child {
      li {
        border-radius: 4px;
      }
    }

    &:first-child {
      li {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    &:last-child {
      li {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }
`;

const Item = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  border: solid 1px #e3e4eb;
  margin-left: -1px;
  min-height: 43px;
  box-sizing: border-box;
  opacity: 0.7;
  cursor: pointer;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.06);

  ${ifProp(
    'isChecked',
    css`
      background: #edeff2;
      border-color: #c1c2c3;
      opacity: 1;
      z-index: 1;
      cursor: default;
    `,
  )};

  ${ifProp(
    'isDisabled',
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `,
  )};
`;

const Option = styled.label`
  display: block;
  padding: 10px 15px;
  cursor: inherit;

  input {
    display: none;
  }
`;

const RadioGroup = (props: Props) => (
  <Options disabled={props.disabled}>
    {props.options.map((option, index) => {
      const isChecked =
        DateUtils.isSameDay(props.selectedFrom, option.fromDate) &&
        DateUtils.isSameDay(props.selectedTo, option.toDate);

      const isDisabled = defaultTo(option.disabled, false);
      const value = format(option.fromDate, 'YYYY-MM-DD');
      const { fromDate, toDate } = option;
      return (
        <FormattedMessage
          id="subscription.unavailableTooltip"
          defaultMessage="Полный отчет доступен с 999 Premium."
          key={index}
        >
          {message => (
            <SubscriptionTooltip
              disabled={!isDisabled}
              title={toString(message)}
            >
              <Item key={value} isChecked={isChecked} isDisabled={isDisabled}>
                <Option>
                  <input
                    name={props.name}
                    value={value}
                    onChange={() => {
                      !isDisabled && props.onChange(fromDate, toDate);
                    }}
                    type="radio"
                    checked={isChecked}
                    disabled={isDisabled}
                  />

                  {option.label}
                </Option>
              </Item>
            </SubscriptionTooltip>
          )}
        </FormattedMessage>
      );
    })}
  </Options>
);

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/RadioGroupDayPicker/index.js